module.exports = __webpack_public_path__ + "static/media/74456377_2628030093915335_4662854772733247488_o.af6b96f6.png";